const mountPublicApp = () => {
  import(
    /* webpackChunkName: "public-app" */ '../public/bootstrap'
  )
    .then(({default: bootstrap}) => {
      bootstrap();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load public chunk', error);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountPublicApp);
} else {
  mountPublicApp();
}
